import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=3491c0bc&scoped=true"
import script from "./Template.vue?vue&type=script&setup=true&lang=js"
export * from "./Template.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Template.vue?vue&type=style&index=0&id=3491c0bc&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491c0bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3491c0bc')) {
      api.createRecord('3491c0bc', component.options)
    } else {
      api.reload('3491c0bc', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=3491c0bc&scoped=true", function () {
      api.rerender('3491c0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/preventive-maintenance/list/Template.vue"
export default component.exports